export default "__VITE_ASSET__iraJI5BF__ 400w, __VITE_ASSET__BXH7vmo3__ 800w, __VITE_ASSET__DbiuV0kB__ 1024w";